import type { ComponentProps } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { CardSkeleton } from "@/components/Skeleton";
import CareerProfileFocusedChrome from "../_CareerProfileFocusedChrome";
import { useCareerProfileQuery } from "../_useCareerProfileQuery";

type FocusedBackLink = NonNullable<ComponentProps<typeof CareerProfileFocusedChrome>["backLink"]>;

export default function ExperienceIndexLayout() {
  const location = useLocation();
  const query = useCareerProfileQuery();
  const isAssessment = /\/assessment\/?$/.test(location.pathname);

  if (!query.flagsLoaded || !query.capabilitiesLoaded) return null;
  if (query.employmentRedirect) return <Navigate to={query.employmentRedirect} replace />;
  if (!query.pgaId) return null;

  return (
    <CareerProfileFocusedChrome
      pgaId={query.pgaId}
      activeTab="experience-index"
      backLink={
        isAssessment
          ? ({
              to: "/people/:pgaId/career/career-profile/experience-assessment",
              params: { pgaId: query.pgaId },
              title: "Back"
            } as FocusedBackLink)
          : undefined
      }
    >
      {query.loading ? (
        <CardSkeleton className="mt-12 w-full" rows={6} />
      ) : query.error ? (
        <div className="mt-12">Error: {query.error.message}</div>
      ) : (
        <Outlet context={query} />
      )}
    </CareerProfileFocusedChrome>
  );
}
